<template>
    <v-autocomplete 
        v-bind="$attrs"
        v-on="$listeners"
        :loading="isLoading"
        :search-input.sync="searchInput"  
        :items="data"
        @input="selectItem"
        @focus="triggerLazySearch"
        ref="VAutocomplete"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>   
    </v-autocomplete>
</template>
<script>
import { asyncGet } from '@/helpers/asyncAxios'
export default {
  name: 'DelayAutocomplete',
  props: {
    url: {
      type: String,
      required: true,
    },
    lazySearch: {
      type: Boolean,
      default: false,
    },
    autoSelectFirst: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      searchInput: '',
      data: [],
      searchDelayTimer: null,
      firstSearch: false,
      abortController: null,
    }
  },
  watch: {
    searchInput(value) {
      if (this.lazySearch && !this.firstSearch) return

      if (this.searchDelayTimer) clearTimeout(this.searchDelayTimer)

      this.searchDelayTimer = setTimeout(this.search, 250, value)
    },
    '$attrs.value': {
      handler(newValue) {
        if (!newValue) {
          this.data = null
          return
        }

        if (!Array.isArray(newValue)) {
          // Single Select
          this.data = [newValue]
          return
        }

        if (this.data.length == 0 && newValue.length != 0) {
          // Multiple Select
          this.data = [...newValue]
        }
      },
      deep: true,
    },
    url() {
      this.searchInput = ''
    },
  },
  methods: {
    async search(searchInput) {
      const root = this.$root

      if (this.abortController) {
        this.abortController.abort()
      }

      this.abortController = new AbortController()

      this.isLoading = true
      try {
        const response = await asyncGet(
          this.url,
          { search: searchInput },
          {
            signal: this.abortController.signal,
          },
        )
        this.data = response
      } catch (error) {
        console.log(error)
      } finally {
        this.abortController = null
      }
      this.isLoading = false

      if (this.data.length == 0) return

      if (!!this.$attrs.value) return

      if (this.autoSelectFirst && !this.firstSearch) {
        this.selectItem(this.data[0])
        this.firstSearch = true
      }
    },
    selectItem(value) {
      this.$emit('input', value)
    },
    triggerLazySearch() {
      if (this.lazySearch && !this.firstSearch) {
        this.firstSearch = true
        this.search('')
      }
    },
  },
}
</script>